import { ResponseDataGet } from "../../../models/responseDataGet";
import { ResponseDataTest } from "../../../models/responseDataTest";
import { agroApi } from "../api";
import { EntStockFilter } from "../../../models/filters/stockFilter";
import { EntStock } from "../../../models/chemicalization/stock";
import { Paths } from "../../../paths";

export const stockApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({

	getStockList: builder.query<ResponseDataGet<EntStock>, EntStockFilter>({
	  query: (filter) => ({
		url: `${Paths.chemicalization.stock}/get-all`,
		method: "POST",
		body: JSON.stringify(filter),
	  }),
	}),

	getStockById: builder.query<ResponseDataTest<EntStock>, number>({
	  query: (id) => ({
		url: `${Paths.chemicalization.stock}/${ id }`,
		method: 'GET'
	  })
	}),
	addStock: builder.mutation<ResponseDataTest<EntStock>, EntStock>({
	  query: (body) => ({
		url: `${Paths.chemicalization.stock}`,
		method: "POST",
		body: JSON.stringify(body)
	  }),
	}),
	editStock: builder.mutation<ResponseDataTest<EntStock>, EntStock>({
	  query: (body,) => ({
		url: `${Paths.chemicalization.stock}`,
		method: 'PUT',
		body: JSON.stringify(body),
	  }),
	}),
	deleteStock: builder.mutation<ResponseDataTest<EntStock>, number>({
	  query: (id) => ({
		url: `${Paths.chemicalization.stock}/${ id }`,
		method: 'DELETE',
	  }),
	}),
  }),
  overrideExisting: false,
});

export const {
  useAddStockMutation,
  useDeleteStockMutation,
  useEditStockMutation,
  useLazyGetStockListQuery
} = stockApi;
